(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessory-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Slick slider
    $('.ass-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 1025, settings: { slidesToShow: 3 } },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '30px',
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '12%',
          },
        },
      ],
    });

    // Wishlist
    let wishlist = JSON.parse(localStorage.getItem('ass_wishlist')) || [];
    document.querySelectorAll('.ass-wishlist-btn').forEach((btn) => {
      const pid = btn.dataset.id;
      const icon = btn.querySelector('.ass-wishlist-icon');
      if (wishlist.includes(pid)) {
        btn.classList.add('active');
        icon.classList.add('active');
      }
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (wishlist.includes(pid)) {
          wishlist = wishlist.filter((id) => id !== pid);
          btn.classList.remove('active');
          icon.classList.remove('active');
        } else {
          wishlist.push(pid);
          btn.classList.add('active');
          icon.classList.add('active');
        }
        localStorage.setItem('ass_wishlist', JSON.stringify(wishlist));
      });
    });

    // Ajax Add To Cart + Animation
    document.querySelectorAll('.ass-cart-form').forEach((form) => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = form.querySelector('.ass-cart-btn');
        btn.disabled = true;
        btn.classList.add('adding');

        const formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then((res) => res.json())
          .then(() => {
            fetch('/cart.js')
              .then((res) => res.json())
              .then((cart) => {
                import('@theme/events').then(({ CartUpdateEvent }) => {
                  document.dispatchEvent(
                    new CartUpdateEvent(cart, 'manual-trigger', {
                      itemCount: cart.item_count,
                      source: 'ass',
                      sections: {},
                    })
                  );
                });
              });
            btn.classList.add('added');
            setTimeout(() => {
              btn.disabled = false;
              btn.classList.remove('adding', 'added');
            }, 2000);
          })
          .catch((err) => {
            console.error(err);
            btn.disabled = false;
            btn.classList.remove('adding');
            btn.classList.add('error');
            setTimeout(() => btn.classList.remove('error'), 2000);
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-sold-product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Slick slider
    $('.msp-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false, // arrows are bound manually below (desktop + mobile buttons)
      dots: false,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 1025, settings: { slidesToShow: 3 } },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '30px',
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '12%',
          },
        },
      ],
    });

    // Bind ALL prev/next buttons (desktop header + mobile overlay) to control the slider
    document.querySelectorAll('.msp-section .prev').forEach((btn) => {
      btn.addEventListener('click', () => $('.msp-slider').slick('slickPrev'));
    });
    document.querySelectorAll('.msp-section .next').forEach((btn) => {
      btn.addEventListener('click', () => $('.msp-slider').slick('slickNext'));
    });

    // Wishlist
    let wishlist = JSON.parse(localStorage.getItem('msp_wishlist')) || [];
    document.querySelectorAll('.msp-wishlist-btn').forEach((btn) => {
      const pid = btn.dataset.id;
      const icon = btn.querySelector('.msp-wishlist-icon');
      if (wishlist.includes(pid)) {
        btn.classList.add('active');
        icon.classList.add('active');
      }
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (wishlist.includes(pid)) {
          wishlist = wishlist.filter((id) => id !== pid);
          btn.classList.remove('active');
          icon.classList.remove('active');
        } else {
          wishlist.push(pid);
          btn.classList.add('active');
          icon.classList.add('active');
        }
        localStorage.setItem('msp_wishlist', JSON.stringify(wishlist));
      });
    });

    // Ajax Add To Cart + Animation
    // document.querySelectorAll(".msp-cart-form").forEach(form=>{
    //   form.addEventListener("submit", function(e){
    //     e.preventDefault();
    //     const btn = form.querySelector(".msp-cart-btn");
    //     btn.disabled = true;
    //     btn.classList.add("adding");

    //     const formData = new FormData(form);
    //     fetch("/cart/add.js", { method:"POST", body:formData, headers:{"X-Requested-With":"XMLHttpRequest"} })
    //       .then(res=>res.json())
    //       .then(()=>{
    //         fetch("/cart.js").then(res=>res.json()).then(cart=>{
    //           import('@theme/events').then(({CartUpdateEvent})=>{
    //             document.dispatchEvent(new CartUpdateEvent(cart, 'manual-trigger', { itemCount: cart.item_count, source:'msp', sections:{} }));
    //           });
    //         });
    //         btn.classList.add("added");
    //         setTimeout(()=>{ btn.disabled=false; btn.classList.remove("adding","added"); },2000);
    //       })
    //       .catch(err=>{ console.error(err); btn.disabled=false; btn.classList.remove("adding"); btn.classList.add("error"); setTimeout(()=>btn.classList.remove("error"),2000); });
    //   });
    // });

    const cartBtnLabels = {
      de: {
        default: 'In den Warenkorb →',
        adding: 'Wird hinzugefügt...',
        added: 'Hinzugefügt ✔',
        error: 'Fehler ✖',
      },
      en: {
        default: 'Add to Cart →',
        adding: 'Adding...',
        added: 'Added ✔',
        error: 'Error ✖',
      },
    };

    document.querySelectorAll('.msp-cart-form').forEach((form) => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const btn = form.querySelector('.msp-cart-btn');
        const locale = document.documentElement.lang === 'de' ? 'de' : 'en'; // Detect language
        const label = cartBtnLabels[locale];

        btn.disabled = true;
        btn.textContent = label.adding;
        btn.classList.add('adding');

        const productId = form.dataset.productId;

        try {
          // Fetch variant from your API
          const response = await fetch(`http://api.unico-swiss.ch/api/products/shopify/${productId}`);
          const data = await response.json();

          if (!data.success || !data.success.data || !data.success.data.first_variant) {
            throw new Error('Variant ID not found');
          }

          const variantId = data.success.data.first_variant.shopify_variant_id;
          form.querySelector('input[name="id"]').value = variantId;

          // Add to cart
          const formData = new FormData(form);
          await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          // Update cart UI
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          import('@theme/events').then(({ CartUpdateEvent }) => {
            document.dispatchEvent(
              new CartUpdateEvent(cart, 'manual-trigger', { itemCount: cart.item_count, source: 'msp', sections: {} })
            );
          });

          // Button state: Added
          btn.textContent = label.added;
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = label.default;
            btn.classList.remove('adding', 'added');
          }, 2000);
        } catch (err) {
          console.error(err);
          btn.disabled = false;
          btn.textContent = label.error;
          btn.classList.remove('adding');
          btn.classList.add('error');
          setTimeout(() => {
            btn.textContent = label.default;
            btn.classList.remove('error');
          }, 2000);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Each "pcs-slider-block" is one independent slider instance
    // (block mode can render multiple sliders on the same page).
    document.querySelectorAll('.pcs-slider-block').forEach(function (block) {
      const $block = $(block);
      const $slider = $block.find('.pcs-slider');

      $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false, // arrows are bound manually below (desktop + mobile buttons)
        dots: false,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3 } },
          { breakpoint: 1025, settings: { slidesToShow: 3 } },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              centerMode: true,
              centerPadding: '30px',
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '12%',
            },
          },
        ],
      });

      // Bind ALL prev/next buttons within THIS block (desktop header + mobile overlay)
      // to control THIS block's slider only.
      $block.find('.prev').on('click', function () {
        $slider.slick('slickPrev');
      });
      $block.find('.next').on('click', function () {
        $slider.slick('slickNext');
      });
    });

    // Wishlist
    let wishlist = JSON.parse(localStorage.getItem('pcs_wishlist')) || [];
    document.querySelectorAll('.pcs-wishlist-btn').forEach((btn) => {
      const pid = btn.dataset.id;
      const icon = btn.querySelector('.pcs-wishlist-icon');
      if (wishlist.includes(pid)) {
        btn.classList.add('active');
        icon.classList.add('active');
      }
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (wishlist.includes(pid)) {
          wishlist = wishlist.filter((id) => id !== pid);
          btn.classList.remove('active');
          icon.classList.remove('active');
        } else {
          wishlist.push(pid);
          btn.classList.add('active');
          icon.classList.add('active');
        }
        localStorage.setItem('pcs_wishlist', JSON.stringify(wishlist));
      });
    });

    // Ajax Add To Cart

    const cartBtnLabels = {
      de: {
        default: 'In den Warenkorb →',
        adding: 'Wird hinzugefügt...',
        added: 'Hinzugefügt ✔',
        error: 'Fehler ✖',
      },
      en: {
        default: 'Add to Cart →',
        adding: 'Adding...',
        added: 'Added ✔',
        error: 'Error ✖',
      },
    };

    document.querySelectorAll('.pcs-cart-form').forEach((form) => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const btn = form.querySelector('.pcs-cart-btn');
        const locale = document.documentElement.lang === 'de' ? 'de' : 'en';
        const label = cartBtnLabels[locale];

        btn.disabled = true;
        btn.textContent = label.adding;
        btn.classList.add('adding');

        try {
          // 1️⃣ Get product ID from form
          const productId = form.dataset.productId;

          // 2️⃣ Call your custom API to get the correct variant ID
          const apiRes = await fetch(`http://api.unico-swiss.ch/api/products/shopify/${productId}`);
          const apiData = await apiRes.json();

          const variantId = apiData?.success?.data?.first_variant?.shopify_variant_id;
          // 3️⃣ Update hidden input with variant ID
          if (variantId !== null && variantId !== undefined) {
            form.querySelector('input[name="id"]').value = variantId;
          }

          // 4️⃣ Prepare FormData
          const formData = new FormData(form);

          // 5️⃣ Add to Shopify cart
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!res.ok) throw new Error('Cart add failed');

          // 6️⃣ Update cart event
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          import('@theme/events').then(({ CartUpdateEvent }) => {
            document.dispatchEvent(
              new CartUpdateEvent(cart, 'manual-trigger', { itemCount: cart.item_count, source: 'pcs', sections: {} })
            );
          });

          // 7️⃣ Show added state
          btn.textContent = label.added;
          btn.classList.add('added');
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = label.default;
            btn.classList.remove('adding', 'added');
          }, 2000);
        } catch (err) {
          console.error(err);
          btn.disabled = false;
          btn.textContent = label.error;
          btn.classList.remove('adding');
          btn.classList.add('error');
          setTimeout(() => {
            btn.textContent = label.default;
            btn.classList.remove('error');
          }, 2000);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    $('.pcs-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 1025, settings: { slidesToShow: 3 } },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '30px',
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '12%',
          },
        },
      ],
    });

    // Wishlist
    let wishlist = JSON.parse(localStorage.getItem('pcs_wishlist')) || [];
    document.querySelectorAll('.pcs-wishlist-btn').forEach((btn) => {
      const pid = btn.dataset.id;
      const icon = btn.querySelector('.pcs-wishlist-icon');
      if (wishlist.includes(pid)) {
        btn.classList.add('active');
        icon.classList.add('active');
      }
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (wishlist.includes(pid)) {
          wishlist = wishlist.filter((id) => id !== pid);
          btn.classList.remove('active');
          icon.classList.remove('active');
        } else {
          wishlist.push(pid);
          btn.classList.add('active');
          icon.classList.add('active');
        }
        localStorage.setItem('pcs_wishlist', JSON.stringify(wishlist));
      });
    });

    // Ajax Add To Cart

    const cartBtnLabels = {
      de: {
        default: 'In den Warenkorb →',
        adding: 'Wird hinzugefügt...',
        added: 'Hinzugefügt ✔',
        error: 'Fehler ✖',
      },
      en: {
        default: 'Add to Cart →',
        adding: 'Adding...',
        added: 'Added ✔',
        error: 'Error ✖',
      },
    };

    document.querySelectorAll('.pcs-cart-form').forEach((form) => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const btn = form.querySelector('.pcs-cart-btn');
        const locale = document.documentElement.lang === 'de' ? 'de' : 'en';
        const label = cartBtnLabels[locale];

        btn.disabled = true;
        btn.textContent = label.adding;
        btn.classList.add('adding');

        try {
          // 1️⃣ Get product ID from form
          const productId = form.dataset.productId;

          // 2️⃣ Call your custom API to get the correct variant ID
          const apiRes = await fetch(`http://api.unico-swiss.ch/api/products/shopify/${productId}`);
          const apiData = await apiRes.json();

          const variantId = apiData?.success?.data?.first_variant?.shopify_variant_id;
          // 3️⃣ Update hidden input with variant ID
          if (variantId !== null && variantId !== undefined) {
            form.querySelector('input[name="id"]').value = variantId;
          }

          // 4️⃣ Prepare FormData
          const formData = new FormData(form);

          // 5️⃣ Add to Shopify cart
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!res.ok) throw new Error('Cart add failed');

          // 6️⃣ Update cart event
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          import('@theme/events').then(({ CartUpdateEvent }) => {
            document.dispatchEvent(
              new CartUpdateEvent(cart, 'manual-trigger', { itemCount: cart.item_count, source: 'pcs', sections: {} })
            );
          });

          // 7️⃣ Show added state
          btn.textContent = label.added;
          btn.classList.add('added');
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = label.default;
            btn.classList.remove('adding', 'added');
          }, 2000);
        } catch (err) {
          console.error(err);
          btn.disabled = false;
          btn.textContent = label.error;
          btn.classList.remove('adding');
          btn.classList.add('error');
          setTimeout(() => {
            btn.textContent = label.default;
            btn.classList.remove('error');
          }, 2000);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
